"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContainer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStyle = styled_components_1.createGlobalStyle `
	@font-face {
		font-family: 'QsiteCustomFont';
		src: url('./FormaDJRDeck-Regular.woff2') format('woff2'),
			url('./FormaDJRDeck-Regular.woff') format('woff');
		font-weight: normal;
		font-style: normal;
	}

	body {
		font-family: 'QsiteCustomFont', sans-serif;
	}

	// All elements should inherit the font-family
	* {
		font-family: inherit;
	}
`;
const Container = styled_components_1.default.div `
	font-size: ${({ theme, customStyle }) => { var _a, _b, _c; return (_c = (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.fontSize) !== null && _c !== void 0 ? _c : theme.baseFontSize; }};
	inline-height: ${({ customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.fontInlineHeight; }};
	text-align: ${({ customStyle }) => { var _a, _b, _c; return (_c = (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.textAlign) !== null && _c !== void 0 ? _c : 'center'; }};
	justify-content: ${({ customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.content) === null || _a === void 0 ? void 0 : _a.justify) !== null && _b !== void 0 ? _b : 'center'; }};
	max-width: 60em;
	margin: 0 auto;

	@media (max-width: 41em) {
		padding: 20px 0;
	}
	
	.location-info {
		color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.gray2; }};
	}

	a {
		color: ${({ theme, customStyle }) => { var _a; return ((_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.hyperlink) || theme.denimBlue; }};
		text-decoration: none;
	}
`;
const FlexContainer = styled_components_1.default(Container) `
	display: flex;
	flex-direction: column;
	justify-content: ${({ customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.content) === null || _a === void 0 ? void 0 : _a.justify) !== null && _b !== void 0 ? _b : 'space-between'; }};
	align-items: center;
	align-content: center;
	text-align: ${({ customStyle }) => { var _a, _b, _c; return (_c = (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.textAlign) !== null && _c !== void 0 ? _c : 'center'; }};
	width: 100%;
	margin: 0 auto;
`;
const PageContainer = (_a) => {
    var { children, flex, customStyle } = _a, rest = __rest(_a, ["children", "flex", "customStyle"]);
    return react_1.default.createElement("main", { className: 'main-container', id: 'main-content', tabIndex: -1 }, react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GlobalStyle, null),
        flex ?
            react_1.default.createElement(FlexContainer, Object.assign({ "data-testid": 'content-container', customStyle: customStyle }, rest), children)
            :
                react_1.default.createElement(Container, Object.assign({ "data-testid": 'content-container', customStyle: customStyle }, rest), children)));
};
exports.PageContainer = PageContainer;
